import React from 'react';
import TopNav from '../../components/TopNav';
import CatchRegisterTemp from '../../images/catch/catch_register_temp.jpg';
import CatchRegisterTemp2x from '../../images/catch/catch_register_temp@2x.jpg';

const Header = () => {
  return (
    <header>
      <TopNav />
      <div className="catch sub">
        <img
          src={ CatchRegisterTemp }
          srcSet={ `${ CatchRegisterTemp } 1x, ${ CatchRegisterTemp2x } 2x` }
          alt="仮登録完了"
        />
      </div>
    </header>
  );
}

export default Header;
